export default __webpack_public_path__ + "static/adylet-3289b7b5501f57256d74164540e5237c.png";